import IConfigWatermark from './Interfaces/IConfigWatermark';

const ONE_SECOND_IN_MS = 1000;
const ONE_MINUTE_IN_MS = 60 * ONE_SECOND_IN_MS;

class ConfigWatermark implements IConfigWatermark {
    public content               = '';
    public displayRangeDuration  = 10 * ONE_SECOND_IN_MS;
    public displayOffsetDuration = 10 * ONE_SECOND_IN_MS;
    public intervalDuration      = 15 * ONE_MINUTE_IN_MS;
    public wobbleRangeDuration   = 2 * ONE_MINUTE_IN_MS;
    public wobbleOffsetDuration  = -ONE_MINUTE_IN_MS;

    public get showWatermark(): boolean {
        return this.content !== '';
    }

    constructor() {
        Object.seal(this);
    }
}

export default ConfigWatermark;